import LoginForm from '../LoginForm/index.vue';
import { getStorage } from '@/plugins/store';
export default {
  name: 'login',
  components: {
    LoginForm
  },
  created() {
    this.getObjectStatus();
    this.getBaseInfo();
    this.getUserInfoLogin();
    this.getProjectLoginText();
  },
  data() {
    return {
      redirect: undefined,
      projectInfo: null,
      loginBanner: '' // 登录页左侧banner
    };
  },

  methods: {
    // 获取登录页配置信息
    async getProjectLoginText() {
      const res = await this.$http.getProjectLogin();
      console.log('登录', res);
      if (res.length) {
        const result = res.find(item => item.key == 'kcsz_case_login_images');
        this.loginBanner = result ? result.value : '';
      }
    },
    getBaseInfo() {
      this.projectInfo = getStorage('projectBaseData');
      console.log('基础配置信息', this.projectInfo);
    },
    // 项目状态
    async getObjectStatus() {
      const res = await this.$http.getObjectStatus();
      console.log('状态', res);
      if (!res.status) {
        window.location.href = '/stop.html';
      }
    },
    // 获取用户信息
    async getUserInfoLogin() {
      let token = this.$utils.getCookie('X-Access-Token');
      if (token) {
        const userInfo = await this.$http.getUserInfo();
        this.userInfo = userInfo;
        window.location.href = '/index.html';
        console.log('用户信息', userInfo);
        return;
      }
      // 是否需要登录
      if (this.isNeedLogin) {
        window.location.href = '/login.html';
      }
      return null;
    }
  }
};